var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"setUser-table"},_vm._l((_vm.tabs),function(item,index){return _c('div',{key:index,class:{
      'setUser-tap-left': index === 0,
      'setUser-tap-right': index !== 0 || index !== _vm.tabs.length - 1,
      'setUser-tap-Strategy': index === _vm.tabs.length,
      'setUser-overall': _vm.actived === index,
      'setUser-Single': !(_vm.actived === index),
    },on:{"click":function($event){return _vm.changeListShow(index)}}},[_vm._v(" "+_vm._s(item)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }